import * as React from "react";
// import Accordion from "@mui/material/Accordion";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import Typography from "@mui/material/Typography";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { Box, Button, Card, CardContent, useMediaQuery } from "@mui/material";
// import ExportDataasCSV from "../../../GlobalComponents/ExportDataasCSV";
// import AuditDataList from "../../../GlobalComponents/AuditDataList";
// import AuditDataListfromApi from "../../../GlobalComponents/AuditDataListfromApi";

 import WhatsAppButton from "../../../GlobalUtilities/whatsapp/WhatsAppButton";





function LocalDashBoard() {
  // const [expanded, setExpanded] = React.useState("");
  // const isMobile = useMediaQuery("(max-width:600px)"); // Check if screen size is mobile

  // const handleChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };


  // const phoneNumber = '+919450887365'; // Replace with your WhatsApp phone number
  // const message = 'Admin! Help on following Topic';
  // const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;



  return (
    <div style={{ width: "100%" }}>
      {/* <Card className="Formcard">
        <CardContent>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            sx={{
              backgroundColor: "red",
              color: "white",
              width: "100%",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ color: "white" }}
            >
              <Typography
                component="span"
                sx={{
                  width: "33%",
                  flexShrink: 0,
                  fontSize: isMobile ? "0.8rem" : "1.2rem", // Smaller font size for mobile
                }}
              >
                DashBoard 1
              </Typography>
            </AccordionSummary>
            <AccordionDetails  >
            <div>
      <div
        style={{
          backgroundColor: '#000000', // Red background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
    DashBoard 1
      </div>
      <div
        style={{
          backgroundColor: '#3f51b5', // Blue background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
        Report 2 
      </div>
      <div
        style={{
          backgroundColor: 'white', // Green background
          color: 'black',
          padding: '16px',
          borderRadius: '8px',
        }}
      >
       DashBoard 1
      </div>
    </div>


            </AccordionDetails>
          </Accordion>
      
 
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
        sx={{ backgroundColor: "green", color: "white", width: "100%" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          sx={{ color: "white" }}
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
          DashBoard 2
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        




	      

<div>
      <div
        style={{
          backgroundColor: '#000000', // Red background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
       DashBoard 2      </div>
      <div
        style={{
          backgroundColor: '#3f51b5', // Blue background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
         DashBoard 2
      </div>
      <div
        style={{
          backgroundColor: 'white', // Green background
          color: 'black',
          padding: '16px',
          borderRadius: '8px',
        }}
      >
        DashBoard 2
      </div>
    </div>

  </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{ backgroundColor: "navy", color: "white", width: "100%" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          sx={{ color: "white" }}
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
          DashBoard 3

          </Typography>
        </AccordionSummary>
        <AccordionDetails>
      


        <div>
      <div
        style={{
          backgroundColor: 'green', // Red background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
         DashBoard 3
      </div>
      <div
        style={{
          backgroundColor: 'red', // Blue background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
          DashBoard 3
      </div>

</div>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === "panel11"}
        onChange={handleChange("panel11")}
        sx={{ backgroundColor: "black", color: "white", width: "100%" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{ color: "white" }}
        >
          
              <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
              DashBoard 4
              </Typography>
           
                 </AccordionSummary>
        <AccordionDetails>
        <div>
      <div
        style={{
          backgroundColor: 'white', // Red background
          color: 'black',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
        DashBoard 4
      </div>
      <div
        style={{
          backgroundColor: '#3f51b5', // Blue background
          color: 'white',
          padding: '16px',
          marginBottom: '8px',
          borderRadius: '8px',
        }}
      >
       DashBoard 4
      </div>

</div>
        </AccordionDetails>
      </Accordion>
       </CardContent>
       </Card>

  <WhatsAppButton /> */}

       <div style={{ textAlign: "center", marginTop: "20px" }}>
        <a
          href={WhatsAppButton}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "white",
            backgroundColor: "#25D366",
            padding: "10px 20px",
            borderRadius: "5px",
          }}
        >
          DashBoard Will apear here
        </a>
      </div>  
    </div>
  );
}
export default LocalDashBoard;
